/**
 * Frontend-side plan-tier helpers — mirror of backend src/common/plan/plan.types.ts.
 * Keep this list in sync if a new tier is added. The only thing the
 * frontend cares about is rank ordering and labels for upgrade CTAs.
 */
export const PLAN_TIERS = ['free', 'growth', 'global', 'enterprise'] as const;
export type PlanCode = typeof PLAN_TIERS[number];

export const PLAN_RANK: Record<PlanCode, number> = {
  free:       0,
  growth:     1,
  global:     2,
  enterprise: 3,
};

export const PLAN_LABELS: Record<PlanCode, string> = {
  free:       'Free',
  growth:     'Growth',
  global:     'Global',
  enterprise: 'Enterprise',
};

/** Per-seat list price in USD cents — mirrors /pricing. */
export const PLAN_UNIT_PRICE_CENTS: Record<PlanCode, number> = {
  free:       0,
  growth:     800,
  global:     1900,
  enterprise: 3900,
};

/** Free-tier limits — used to render seat-count chip etc. */
export const FREE_SEAT_LIMIT = 10;
export const FREE_COUNTRY_LIMIT = 1;

export function planMeets(actual: PlanCode | string | null | undefined, required: PlanCode): boolean {
  const norm = ((actual ?? 'free') as string).toLowerCase() as PlanCode;
  const a = PLAN_RANK[norm];
  if (a == null) return false;
  return a >= PLAN_RANK[required];
}
